// extracted by mini-css-extract-plugin
export default {"resources":"ListOfLinks_resources__uiuGZ"};